import { API } from '.';
import { handleResponse } from '../helpers';
import { API_URL } from '../config/appConfig';

const getClientBasicInfo = (clientId) => {
  return API.get(
    `${API_URL.idpAuth}/client/${clientId}/basic`,
    "client_info"
  ).then(res => {
    return handleResponse(res, true);
  });
};

export const clientService = {
  getClientBasicInfo
};